<div class="message-container">
  <mat-toolbar mat-dialog-title color="primary" class="message-dialog-toolbar">
    <span class="device-dialog-title">{{ data.itemData.eventTypeId }}</span>
  </mat-toolbar>

  <div class="message-dialog-date row">
    <h3 class="bold">{{ 'messages.table.header.date' | translate }}</h3>
    <h3>{{data.itemData.sentTimestamp | defaultDate}}</h3>
  </div>

  <div>
    <h3 class="message-inner-container-header row bold">{{ 'messages.table.header.message' | translate }}</h3>
  </div>
  <div class="message-inner-container row">
    <p>{{data.itemData.messageContent}}</p>
  </div>

  <mat-dialog-actions class="message-footer row" align="end">
    <button mat-flat-button [mat-dialog-close]="true" color="primary" class="close-button">{{
        'button.close' |
          translate
      }}
    </button>
  </mat-dialog-actions>
</div>
